export const FONTS = [
  'sans-serif',
  'Open Sans',
  'Verdana',
  'Times New Roman',
  'Comic Sans MS',
  'Courier New',
  'Georgia',
  'Tahoma',
  'Arial',
  'SalesforceSans-Bold',
  'SalesforceSans-BoldItalic',
  'SalesforceSans-Book',
  'SalesforceSans-Italic',
  'SalesforceSans-Light',
  'SalesforceSans-LightItalic',
  'SalesforceSans-Regular',
  'SalesforceSans-Thin',
  'SalesforceSans-ThinItalic'
];

export function getFontSizes() {
  const fontSizes = [];

  for (let i = 6; i <= 30; i++) {
    if (i <= 11 || i % 2 === 0) {
      fontSizes.push(i + 'px');
    }
  }

  return fontSizes;
}
